// Module
var code = "<h2 class=\"interiorSectionHeading\"> False Certification as a Result of Identity Theft Loan Discharge </h2> <p>You may qualify for loan discharge if your loan was falsely certified because of identity theft.</p> ";
// Exports
export default code;